export const onKeyDown = (e: any) => {
  if (
    e.keyCode !== 8 &&
    e.keyCode !== 37 &&
    e.keyCode !== 39 &&
    e.target.selectionStart === (e.target.value || '').length &&
    e.target.selectionStart === e.target.selectionEnd &&
    e.target.value > 0
  ) {
    e.preventDefault()
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/keycode.ts